import React from 'react';

const strings =
{
  //  Intro page
  'intro title': {
    de: 'Multicle Prototyp',
    en: 'Multicle prototype'
  },
  'intro paragraph 1': {
    de: 'Wir haben Multicle entwickelt, ein neues digitales Artikelformat, das sich den Wünschen der Leserinnen und Leser anpasst.',
    en: 'We have developed Multicle, a new format for online articles that adapts to the reader’s preferences'
  },
  'intro paragraph 2': {
    de: 'Hier kannst Du den ofenfrischen Prototyp testen. Wir hoffen, dass dir die darin erzählte Geschichte gefällt. Sie ist allerdings nur als Beispiel gedacht – eine unter vielen möglichen Storys. Wichtiger ist uns, dass du auf die Form achtest und die verschiedenen Arten ausprobierst, auf die du dich durch den Inhalt bewegen kannst.',
    en: 'You can test the brand-new prototype right here. We hope that you will like the story in contains. But remember, it is just an example, one among many possible stories that can be told with a Multicle. We would like you to pay more attention to the form and to the way you can move through the content.'
  },
  'intro paragraph 3': {
    de: (url) => <span>Am Schluss des Prototyps findest du einen Link zu einer kurzen <a href={url}>Umfrage</a>. Wenn du sie ausfüllst, hilfst du uns, Multicle zu verbessern und weiter zu entwickeln. Vielen Dank!</span>,
    en: (url) => <span></span>
  },
  'intro mobile text': {
    de: 'Wir haben Multicle entwickelt, ein neues digitales Artikelformat, das sich den Wünschen der Leserinnen und Leser anpasst.',
    en: 'We have developed Multicle, a new format for online articles that adapts to the reader’s preferences'  
  },
  'button test prototype': {
    de: 'Zum Prototyp',
    en: 'Go to prototoype'
  },
  'button link documentation': {
    de: 'Mehr über Multicle',
    en: 'More about Multicle'
  },
  'landing multicle title': {
    de: 'Wettstreit der Cyborgs',
    en: 'Meet the Cyborgs'
  },
  'landing remaining button': {
    de: 'Alle ungelesenen Particles anzeigen',
    en: 'Show all unread particles'
  },
  'landing remaining header': {
    de: 'verbleibend',
    en: 'remaining'
  },
  'landing remaining all read': {
    de: 'Alles gelesen!',
    en: 'All read!'
  },
  'landing survey link': {
    de: 'Sag uns deine Meinung zu Multicle!',
    en: 'Tell us what you think about Multicle!'
  },
  // Docs page
  'docs headline 1': {
    de: 'Non-linear. Non-langweilig.',
    en: 'Non-linear. Non-lame.'
  },
  'docs link to prototype': {
    de: 'Zum Prototyp',
    en: 'Go to prototype',
  },
  'docs subtitle': {
    de: 'Ein neues digitales Artikelformat, das sich den Wünschen der Leserinnen und Leser anpasst',
    en: 'A new format for online articles that adapts to the reader’s preferences'
  },
  'docs headline 2': {
    de: 'Wer hinter Multicle steckt',
    en: 'Who we are'
  },
  'docs paragraph 1': {
    de: 'Bei Multicle entscheiden die Leserinnen und Leser, was sie lesen wollen. Sie vertiefen ein Thema dann, wenn sie mehr wissen wollen. Sie haken nach und erfahren, was sie interessiert.',
    en: 'With Multicle, users decide what they read. If they want to know more, they dig deeper into a topic, explore hidden corners and find what is interesting to them.'  
  },
  'docs paragraph 2': {
    de: 'Normalerweise wird eine Geschichte linear vom Anfang bis zum Ende erzählt. Nicht so bei Multicle: Hier besteht sie aus kleinen Informationseinheiten, die wir Particles nennen. Diese sind alle miteinander verknüpft. Du kannst sie in der Reihenfolge konsumieren, die deinen Interessen entspricht. Beim Lesen merkst du das vielleicht gar nicht. Und trotzdem liest du wohl nicht dieselbe Geschichte wie deine Freunde.',
    en: 'Usually, a story is told from beginning to end, in a linear fashion. Not with Multicle. Here, the story is built from small entities of information that we call particles. Those are all connected to each other. You can chose in which order you want to read them and which are the ones that you are most interested in. Thereby, you create your own story. You might not even notice that while reading, but you probably won’t read the same story as your friends.'
  },
  'docs paragraph 3': {
    de: 'So kann mit Multicle jede Geschichte kurz oder lang sein. Oder noch länger. Einfach oder komplex. Voller Fakten oder voller Erlebnisse.',
    en: 'Thereby, every Multicle story can be either short or long. Or even longer. Simple or complex. Full of facts or full of experiences.'
  },
  'docs paragraph 4': {
    de: 'Multicle ist eine Zusammenarbeit zwischen Wissenschaftsjournalisten von Scitec-Media sowie Designern und Programmierern von Interactive Things:',
    en: 'Multicle is a collaboration between science journalists from Scitec-Media and designers and programmers from Interactive Things.'
  },
  'docs paragraph 5': {
    de: 'Gerne erzählen wir dir mehr über Multicle:',
    en: 'Would you like to know more about Multicle?'
  },
  'docs button action': {
    de: 'Tritt mit uns in Kontakt',
    en: 'Just drop us a line!'
  },
  //  Particles
  '': {
    de: ''
  },
};

export const translate = (lang, lookup, content) => {
  const item = strings[lookup] || {};
  const value = item[lang];
  // check if value is a function, then provide arguments to it
  // otherwise just
  const template = typeof value === 'function'
    ? value( content || null )
    : value;
  return template || `No translation found for "${lookup}" / ${lang}`;
}



/** WEBPACK FOOTER **
 ** ./src/actions/translate.js
 **/